/* eslint-disable react-hooks/rules-of-hooks */
import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { queryClient } from '../helpers/queryClient';
import { TriggerRefreshRequest } from './interface';

const initialValuesTriggerRefresh: TriggerRefreshRequest = {
  keyMetric: false,
  exams: false,
  accountability: false,
  wellness: false,
  actionItems: false,
}


export const ARMcontext = createContext({
  test: '',
  reload: false,
  toast: {} as any,
  user: {} as any,
  teamMemo: [] as any,
  selectedTeam: {} as any,
  selectedPlayer: {} as any,
  HandleToastMessage: {} as any,
  width: {} as any,
  height: {} as any,
  dataCreateAccount: {} as any,
  strengthRecovery: {} as any,
  triggerRefresh: initialValuesTriggerRefresh,
  HandleSignOut: () => { },
  ToggleReload: () => { },
  AddTeams: (param: any) => { },
  AddNewTeams: (param: any) => { },
  startTest: (param: string) => { },
  HandleUser: (param: string, data?: string) => { },
  HandleSelectedTeam: (param: any) => { },
  HandleSelectedPlayer: (param: any) => { },
  RemoveSelectedPlayer: () => { },
  HandleDataCreateAccount: (param: string) => { },
  RemoveDataCreateAccount: () => { },
  setStrengthRecovery: (value: any) => { },
  setTriggerRefresh: (value: any) => { },
});




export const ARMprovider = ({ children }: { children: any }) => {
  const [toast, setToast] = useState<object | any>({
    status: false,
    message: '',
    animated: false,
    theme: 'success',
    action: () => { },
  });
  const [selectedTeam, useSelectedTeam] = useState<object | any>(JSON.parse(localStorage.getItem('team') || 'null') || {});
  const [teamMemo, useTeamMemo] = useState<Array<any>>(JSON.parse(localStorage.getItem('teams') || 'null') || []);
  const [user, setUser] = useState<any>(JSON.parse(`${localStorage.getItem('user')}`));
  const [test, setTest] = useState('');
  const [reload, setReload] = useState<boolean>(false);
  const [selectedPlayer, useSelectedPlayer] = useState<object | any>({});
  const [width, setWidth] = React.useState(window.innerWidth);
  const [height, setHeight] = React.useState(window.innerHeight);
  const [dataCreateAccount, setDataCreateAccount] = useState<Object>({});
  const [strengthRecovery, setStrengthRecovery] = useState<Object[]>([]);
  const [triggerRefresh, setTriggerRefresh] = useState<TriggerRefreshRequest>(initialValuesTriggerRefresh);

  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  }

  React.useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  function startTest(param: string): void {
    setTest(param);
  }

  function HandleUser(param: any, data?: any): void {
    if (data) {
      param.data = data;
    }
    setUser(param);
    localStorage.setItem('user', JSON.stringify(param));
  }

  function CheckStorageState(): void {
    try {
      const teamsResult = localStorage.getItem('teams');
      const playerResult = localStorage.getItem('player');
      const createAccountResult = localStorage.getItem('createAccount');

      if (teamsResult !== null) {
        useTeamMemo(JSON.parse(teamsResult));
      }
      if (playerResult !== null) {
        useSelectedPlayer(JSON.parse(playerResult));
      }
      if (createAccountResult !== null) {
        setDataCreateAccount(JSON.parse(createAccountResult));
      }
    } catch (error) {
      return console.error({ error: true, message: error });
    }
  }

  function HandleSignOut(): void {
    localStorage.removeItem('team');
    localStorage.removeItem('teams');
    localStorage.removeItem('player');
    localStorage.removeItem('user');
    useSelectedPlayer({});
    setUser({});
    queryClient.clear();
  }
  function RemoveSelectedPlayer(): void {
    localStorage.removeItem('player');
    useSelectedPlayer({});
  }
  function AddTeams(teams: Array<any>): void {
    useTeamMemo(previus => {
      const body = [...previus, ...teams];
      localStorage.setItem('teams', JSON.stringify(body));
      if (!selectedTeam?._id) {
        HandleSelectedTeam(body[0]);
      }
      return body;
    });
  }

  function AddNewTeams(teams: Array<any>): void {
    useTeamMemo(teams);
    localStorage.setItem('teams', JSON.stringify(teams));
    if (!selectedTeam?._id) {
      HandleSelectedTeam(teams[0]);
    }
  }

  function HandleSelectedTeam(team: object): void {
    useSelectedTeam(team);
    localStorage.setItem('team', JSON.stringify(team));
  }
  function HandleSelectedPlayer(player: object): void {
    useSelectedPlayer(player);
    localStorage.setItem('player', JSON.stringify(player));
  }

  function HandleToastMessage(message, animated, time = 0, theme = 'success', action = CancelToastMessage): void {
    setToast({ status: true, message, animated, theme, action });
    if (time) {
      setTimeout(() => setToast({ status: false, message, animated, theme, action }), time);
    }
  }

  function HandleDataCreateAccount(param: any): void {
    setDataCreateAccount(param);
    localStorage.setItem('createAccount', JSON.stringify(param));
  }

  function RemoveDataCreateAccount(): void {
    localStorage.removeItem('createAccount');
    setDataCreateAccount({});
  }

  function ToggleReload() {
    setReload(!reload);
  }
  function CancelToastMessage() {
    setToast({ status: false, message: '', animated: false, theme: 'success', action: null });
  }

  useEffect(CheckStorageState, []);

  return (
    <ARMcontext.Provider
      value={{
        test,
        reload,
        user,
        toast,
        teamMemo,
        width,
        height,
        dataCreateAccount,
        AddTeams,
        startTest,
        HandleUser,
        AddNewTeams,
        selectedTeam,
        selectedPlayer,
        HandleSignOut,
        ToggleReload,
        HandleToastMessage,
        HandleSelectedTeam,
        HandleSelectedPlayer,
        RemoveSelectedPlayer,
        HandleDataCreateAccount,
        RemoveDataCreateAccount,
        strengthRecovery,
        setStrengthRecovery,
        triggerRefresh,
        setTriggerRefresh,
      }}>
      {children}
    </ARMcontext.Provider>
  );
};

export const useViewport = () => {
  const { width, height } = React.useContext(ARMcontext);
  return { width, height };
}
